import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/operation/channel',
  title: '渠道管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
